import React from 'react'

interface StepperProps {
  steps: string[]
  currentStep: number
  onStepClick?: (step: number) => void
}

const Stepper: React.FC<StepperProps> = ({
  steps,
  currentStep,
  onStepClick,
}) => {
  return (
    <div className="flex items-center justify-between">
      {steps.map((step, index) => {
        const isCompleted = index < currentStep
        const isActive = index === currentStep

        return (
          <div
            key={index}
            className={`flex items-center justify-center w-full text-common text-primary font-medium px-1 py-2.5 text-center cursor-pointer transition-all duration-300 
              ${
                isCompleted
                  ? 'progressive success text-success'
                  : isActive
                    ? 'progressive filled '
                    : 'progressive default'
              } 
            `}
            onClick={() => onStepClick?.(index)}
          >
            <span className="relative z-10">{`Step ${index + 1}: ${step}`}</span>
          </div>
        )
      })}
    </div>
  )
}

export default Stepper
